import { render, staticRenderFns } from "./ManufacturerTotalOrdersByState.vue?vue&type=template&id=67ff1cfc&"
import script from "./ManufacturerTotalOrdersByState.vue?vue&type=script&lang=js&"
export * from "./ManufacturerTotalOrdersByState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports